export class Controller {
  protected $el: HTMLElement
  protected $refs: Map<string, HTMLElement> = new Map()

  constructor(el: HTMLElement) {
    this.$el = el
    this.loadRefs()
  }

  protected loadRefs() {
    this.$refs = new Map()

    // IDEA: if ref ends with [] then make an array of all the refs with the same name?

    const refs = this.$el.querySelectorAll('[data-ref]')
    refs.forEach((ref) => {
      if (ref instanceof HTMLElement) {
        const refName = ref.dataset.ref
        if (refName) {
          if (this.$refs.has(refName)) {
            console.warn(`Duplicate ref name ${refName}, overwriting previous value.`)
            this.$refs.get(refName)?.removeEventListener('change', this.changeListener)
          }

          this.$refs.set(refName, ref as HTMLElement)
          ref.addEventListener('change', this.changeListener)
        }
      }
    })

    this.valueUpdated()
  }

  private changeListener = (_event: Event) => {
    this.valueUpdated()
  }

  protected valueUpdated() {
  }
}
